import { render, staticRenderFns } from "./MobileViewBoxComponent.vue?vue&type=template&id=784ea966&"
import script from "./MobileViewBoxComponent.vue?vue&type=script&lang=js&"
export * from "./MobileViewBoxComponent.vue?vue&type=script&lang=js&"
import style0 from "./MobileViewBoxComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports